export default "__VITE_ASSET__41e37f2e__"